export default __webpack_public_path__ + "static/media/cultivation.dc618ac7.svg";